module.exports = __webpack_public_path__ + "img/box-item.94becf3f.png";